import ko from 'knockout'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservablePage } from '../../../Model/Observables/IObservablePage'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import type { IUseGiddyUp } from '../../Pages/Starters/IUseGiddyUp'

export class ExactaTopPanelViewModel {
  constructor(params: {
    raceInfo: IObservablePage
    context: {
      raceNumber: ObservableRaceKey
      bettingContext: BettingInformation
      starters: ko.ObservableArray<IObservableStarter>
    }
    useGiddyUp: IUseGiddyUp
  }) {
    this.raceInfo = params.raceInfo
    this.raceNumber = params.context.raceNumber
    this.bettingContext = params.context.bettingContext
    this.starters = params.context.starters
    this.useGiddyUp = params.useGiddyUp
  }

  public hasGiddyUp() {
    if (!this.useGiddyUp) return false
    return this.useGiddyUp.showGiddyUpInTopPanel(this.raceNumber.raceNumber())
  }

  public openGiddyUp() {
    this.useGiddyUp.openGiddyUp()
  }

  public raceInfo: IObservablePage
  public raceNumber: ObservableRaceKey
  public bettingContext: BettingInformation
  public starters: ko.ObservableArray<IObservableStarter>
  public useGiddyUp: IUseGiddyUp
}
